export * from './move-to-start-plate-adapter';
